import React from 'react';
interface ScrollHintTableProps {
  children: React.ReactNode;
  minWidth?: string;
}
export function ScrollHintTable({
  children,
  minWidth = '560px'
}: ScrollHintTableProps) {
  return <div data-id="element-290" data-mp="1i7eim9hxx1bw">
      <p className="mb-2 text-center text-xs font-medium text-ink/60 sm:hidden" data-id="element-291" data-mp="1i6wgiw8ljsw2">
        ← Desliza para ver la tabla completa →
      </p>
      <div className="scrollbar-hide overflow-x-auto rounded-2xl border border-primary/10 shadow-card-light" data-id="element-292" data-mp="1mz62k16lc8t2">
        <div style={{
        minWidth
      }} data-id="element-293" data-mp="1rz2844uxs8aq">{children}</div>
      </div>
    </div>;
}